import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Suspense } from "react";
import { LicenseInfo } from "@mui/x-license";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import "./common/styles/newStyles.css";
import { Settings } from "luxon";
import { routes } from './routes.js';
import { APIProvider } from "@vis.gl/react-google-maps";

Settings.defaultZone = "system";
LicenseInfo.setLicenseKey("96a2fbd083d421c29bdedf8578ff981cTz0xMjcxNjEsRT0xODA1NTAwNzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=");

const App = () => (
  <Suspense fallback={<>...</>}>
    <APIProvider apiKey={'AIzaSyC77M9qn63_jdR7cyTFTuR8BN8GJoK2QUA'} onLoad={() => console.log('Maps API has loaded.')}>
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={"system"}>
      <RouterProvider router={createBrowserRouter(routes)} />
    </LocalizationProvider>
    </APIProvider>
  </Suspense>
);

export default App;
